export * from './paymentprovider-switcher/paymentprovider-switcher.component';
export * from './amazonpay-starter/amazonpay-starter';
export * from './amazonpay/amazonpay';
export * from './spinner/spinner.component';
export * from './googlepay/googlepay';
export * from './applepay/applepay';